// extracted by mini-css-extract-plugin
export default {"wrapper":"OverlayGroupItem_wrapper__Nlvx8","utdanningsbeskrivelse":"OverlayGroupItem_utdanningsbeskrivelse__VNyub"};